<template>
    <div class="forgot-password-modal">
        <div v-if="isSent">
            <div class="notice">{{ $t('change URL sent to your E-mail') | capitalize }}</div>
            <Illustration xl image="/static/img/illustrations/email__sent.svg"/>
        </div>
        <div
            v-else
        >
            <div class="instruction">
                {{ $t('Enter the email address of your Superbet account' +
                    ' and you will receive the password reset link from the email box.') }}
            </div>
            <GenericForm
                :fields="fields"
                :asyncErrors="asyncErrors"
                @submit="onSend"
            >
                <template slot-scope="slotProps">
                    <CustomInput
                        name="email"
                        v-model="fields.email.value"
                        label="E-mail"
                        :errorMessage="slotProps.errors.email"
                        @valueChanged="slotProps.onValueChanged"
                        ref="email"
                    />
                    <CustomButton
                        :isLoading="isLoading"
                        type="submit"
                        class="btn btn__primary btn--block mb-4"
                    >
                        {{ $t('send') | capitalize }}
                    </CustomButton>
                    {{ error }}
                </template>
            </GenericForm>
            <div
                class="help-area"
            >
                <CustomButton
                    @click="showHelp"
                    class="btn btn__icon--left"
                >
                    <i class="icon icon--sm icon-help_circle btn__icon" />
                    {{ $t("help") | capitalize }}
                </CustomButton>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import ValidationError from '@core/errors/network/ValidationError';
    import { authenticationService } from '@core/services/authentication/AuthenticationService';
    import { isEmail, isRequired } from '@modules/shared/validators/forms';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'ForgotPasswordContainer',
        data() {
            return {
                isSent: false,
                isLoading: false,
                error: '',
                fields: {
                    email: {
                        value: null,
                        validate: [
                            isRequired,
                            isEmail
                        ]
                    },
                },
                asyncErrors: {},
            };
        },
        created() {
            this.$nextTick(() => {
                this.$refs.email.focusInput();
            });
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            async onSend() {
                this.isLoading = true;
                this.error = '';
                this.asyncErrors = {};
                await errorGuard({
                    action: async () => {
                        await authenticationService.forgotPasswordRequest(this.fields.email.value);
                        this.isSent = true;
                    },
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.error = 'Something went wrong. Please try again';
                        }
                    },
                    showGlobalError: false,
                });
                this.isLoading = false;
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/resetPassword/ForgotPasswordContainerModal.vue